import { get, post } from ".";


export const addUserToProject = (
    userId,
    projectId,
    role,
    callback,
    errorCallback
  ) => {
    post(
      `project/${projectId}/addMember`,
      {
        user_id: userId,
        role: role,
      },
      (data) => {
        if(callback){
            callback(data)
        }

      },
      errorCallback
    );
  };